export enum EProductMetadataKey {
  PREVIEW_FILE_TYPE = 'previewFileType',
  PREVIEW_SCENES = 'previewScenes',
  PRIMARY_PREVIEW_PRODUCT_UID = 'primaryPreviewProductUid',
  PRIMARY_PREVIEW_PRODUCT_VARIANT_KEY = 'primaryPreviewProductVariantKey',
  PRIMARY_PREVIEW_SCENE = 'primaryPreviewScene',
  ASSETS = 'assets',
  ATTACH_SIZE_GUIDE_CM_TABLE = 'attachSizeGuideCmTable',
  ATTACH_SIZE_GUIDE_INCH_TABLE = 'attachSizeGuideInchTable',
  ATTACH_PRODUCT_CARE_INSTRUCTIONS = 'attachProductCareInstructions',
  PUBLISH_IMMEDIATELY = 'publishImmediately',
  PUBLISH_WITH_FREE_SHIPPING = 'publishWithFreeShipping',
  PUBLISH_MODE = 'publishMode',
  PUBLISH_SCOPES = 'publishScopes',
  TEMPLATE_ID = 'templateId',
  USED_GELATO_PUBLISHER = 'usedGelatoPublisher',
  CREATED_BY_PRODUCT_EXPANSION = 'createdByProductExpansion',
  CREATED_FROM_TEMPLATE = 'createdFromTemplate',
  PRODUCT_CREATED_USING_NEW_BUTTON = 'createdByNewProduct',
  USED_CUSTOM_MOCKUP = 'usedCustomMockup',
  USED_PREMIUM_MOCKUP = 'usedPremiumMockup',
  USED_STANDARD_MOCKUP = 'usedStandardMockup',
  CREATED_BY_UPLOAD_DESIGN = 'createdByUploadDesign',
  GELATO_PUBLISHER_PRODUCT_PUBLISH_MODE = 'gelatoPublisherProductPublishMode',
}
